import styled from '@emotion/styled';
import {
  SvgIcon,
  SvgNames,
  tokens,
  Typography,
} from '@sunrun/experience-ui-components';

type ReferralMobileMetaProps = {
  referredBy?: string;
  createdDate: string;
};

const ReferralMobileMeta = ({
  referredBy,
  createdDate,
}: ReferralMobileMetaProps) => (
  <MetaRow>
    <ReferredBySection>
      <MetaLabel size={12}>Referred by: </MetaLabel>
      {referredBy ? (
        <MetaValue size={12} $truncate>
          {referredBy}
        </MetaValue>
      ) : (
        <NotEnteredInline>
          <MetaValue size={12} $warning>
            Not entered
          </MetaValue>
          <SvgIcon
            name={SvgNames.ErrorOutline}
            width={16}
            height={16}
            color={tokens.ERROR_50}
          />
        </NotEnteredInline>
      )}
    </ReferredBySection>
    <CreatedSection>
      <MetaLabel size={12}>Created: </MetaLabel>
      <MetaValue size={12}>{createdDate}</MetaValue>
    </CreatedSection>
  </MetaRow>
);

const MetaRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  min-width: 0;
  width: 100%;
`;

const ReferredBySection = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  gap: 2px;
`;

const CreatedSection = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 2px;
`;

const MetaLabel = styled(Typography)`
  color: ${tokens.OFFWHITE_20};
  flex-shrink: 0;
  line-height: 1.4;
`;

const MetaValue = styled(Typography)<{
  $warning?: boolean;
  $truncate?: boolean;
}>`
  font-weight: 700;
  line-height: 1.4;
  color: ${({ $warning }) =>
    $warning ? tokens.ERROR_50 : tokens.BRAND_HEROBLUE};
  ${({ $truncate }) =>
    $truncate &&
    `
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;

const NotEnteredInline = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export { ReferralMobileMeta };
